export enum SettingsActionErrors {
    SettingsLoading,
    SettingsUpdate,
    NeighborhoodsMappingLoading,
    NewMatchSettingsLoading,
    NewMatchSettingsUpdate
}